import { RouteType } from "types/RouteType";
import PORequisitionWizardStore from "./PORequisitionWizardStore";

const PORequisitionWizardRoute: RouteType = {
  name: "PORequisitionWizard",
  path: "/workflows/po-requisition",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "PO Requisition & Approval",
      component: () => import("./PORequisitionWizardHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./PORequisitionWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.poRequisitionWizardStore) {
      rootStore.poRequisitionWizardStore = new PORequisitionWizardStore(
        rootStore
      );
    }
    await rootStore.poRequisitionWizardStore.loadInitialData();
    return true;
  },
};

export default PORequisitionWizardRoute;